import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { getTextDate } from 'utils/formattedData';

import type IValueChainTableRows from '../interfaces/IValueChainTableRows';

function ValueChainTableRows({
  vcList,
  selectedItemId,
  onItemSelect,
  styles,
}: IValueChainTableRows) {
  const { t } = useTranslation();
  return (
    <>
      {vcList.map((item) => (
        <tr
          key={`vc-${item.id}`}
          className={clsx(styles.tableRow, {
            [styles.selected]: selectedItemId === item.id,
          })}
          onClick={() => onItemSelect(item)}
          onKeyDown={() => onItemSelect(item)}
          tabIndex={0}
          role="button"
          aria-label={`Select ${item.name}`}
        >
          <td className={styles.nameCell}>{item.name}</td>
          <td className={styles.dateCell}>
            {item?.created?.date
              ? <div>{getTextDate(item?.created?.date)}</div> : null}
            <div className={styles.byAuthor}>
              {item.created.byName
                ? `by ${item.created.byName}` : ''}
            </div>
          </td>
          <td className={styles.dateCell}>
            {item?.lastModified?.date
              ? <div>{getTextDate(item?.lastModified?.date)}</div> : null}
            <div className={styles.byAuthor}>
              {item.lastModified.byName
                ? `by ${item.lastModified.byName}` : ''}
            </div>
          </td>
          <td className={styles.statusCell}>
            <span
              className={clsx(
                styles.statusBadge,
                styles[item.status.toLowerCase()],
              )}
            >
              {item.status ? t(`common.${item.status}`) : ''}
            </span>
          </td>
        </tr>
      ))}
    </>
  );
}

export default ValueChainTableRows;
